'use strict';

angular.module('internal.exams')
    .controller('InternalExamFormPreview', ['$scope', '$stateParams', 'FBResponses',
        function ($scope, $stateParams, FBResponses) {
            $scope.form = $stateParams.form;
            $scope.formID = $stateParams.formID;
            $scope.loading = true;

            if ($stateParams.formID != null) {
                FBResponses.getByID(guid(), $stateParams.formID).then(function (response) {
                    if (response != null) {
                        var form = response.form;
                        if (form.pages.length > 0) {
                            form.pages[0].tab_active = true;
                        }
                        $scope.form = form;
                    }
                    $scope.loading = false;
                })
            }

            $scope.complete = function () {
                return $scope.deficiencies.fail + $scope.deficiencies.pass + $scope.deficiencies.ignore == $scope.checklist.deficiencies_total;
            }

            $scope.failed = function () {
                return $scope.deficiencies.fail >= $scope.checklist.auto_fail;
            }
        }])
    ;